import {Injectable} from "@angular/core";
import {BaseService} from "@core/service/base.service";
import {catchError, tap} from "rxjs/operators";
import {Observable} from "rxjs/index";
import {HttpClient, HttpHeaders, HttpParams, HttpResponse} from '@angular/common/http';

export const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};
@Injectable({providedIn: 'root'})
export class ArticleReaderService extends BaseService {

  private url = 'api/article-reader';  // URL to web api

  constructor(http:HttpClient) {
    super(http);
  }

  getUrl():string {
    return this.url;
  }

  headerQuery(showNum):Observable<any> {
    const url = `${this.getUrl()}/header-query`;
    return this.http.get<any>(url, {
      headers:httpOptions.headers,
      observe: 'response',
      params: {showNum: showNum}
    }).pipe(
      tap(_ => this.log(`headerQuery`)),
      catchError(this.handleError<any>(`headerQuery`))
    );
  }

  view(id):Observable<any> {
    const url = `${this.getUrl()}/view`;
    return this.http.get<any>(url, {
      params: {id: id}
    }).pipe(
      tap(_ => this.log(`headerQuery`)),
      catchError(this.handleError<any>(`headerQuery`))
    );
  }

  readAll():Observable<any> {
    const url = `${this.getUrl()}/read-all`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`readAll`)),
      catchError(this.handleError<any>(`headerQuery`))
    );
  }
}

